import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import type { SpaceToken } from "./Stack";
import styles from "./Grid.module.css";

const gapClass: Record<SpaceToken, string> = {
  4: styles.gap4,
  8: styles.gap8,
  12: styles.gap12,
  16: styles.gap16,
  24: styles.gap24,
  36: styles.gap36,
};

export interface GridProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  columns?: string;
  gap?: SpaceToken;
}

export function Grid({
  children,
  className,
  columns = "repeat(auto-fit, minmax(240px, 1fr))",
  gap = 16,
  style,
  ...rest
}: GridProps) {
  return (
    <div
      className={cn(styles.grid, gapClass[gap], className)}
      style={{ ...style, gridTemplateColumns: columns }}
      {...rest}
    >
      {children}
    </div>
  );
}
